import React, { forwardRef } from 'react';
import { makeStyles } from '@material-ui/styles';
import cn from 'classnames';
import styles from '../styles';
import { Autocomplete } from '../../../Autocomplete';
import { useController, useFormContext } from 'react-hook-form';

const useStyles = makeStyles(theme => ({
  ...styles(theme)
}));

const Select = forwardRef(({
  // props for this component
  error,
  label,
  // disabledOnEdit,

  // props for Autocomplete
  options: opts,
  isMulti,
  placeholder,
  isClearable,
  isFixed=false,
  disabled=false,
  // async,
  // defaultOptions,
  // loadOptions,
  // filterOption,

  // props for react-hook-form
  isAbsolute,
  ...rhfProps
}, ref) => {
  const classes = useStyles();

  const { control } = useFormContext();
  const {
    field,
    fieldState: { invalid, isTouched, isDirty },
    formState: { touchedFields, dirtyFields },
  } = useController({
    ...rhfProps,
    control,
  });
  const options = opts || [];

  return (
    <div className={classes.inputContainer} title={options.length ? `${options.length} options` : undefined}>
      <p className={cn(classes.inputLabel, classes.fieldLabel, error && classes.textLabelError)}>
        {label}
        {!!error && `: ${error}`}
      </p>

      <Autocomplete
        {...field}
        ref={ref}
        className={classes.selectInput}
        value={field.value !== undefined && field.value !== null ? options.find(opt => opt.value === field.value) : null}
        options={options}
        menuPosition={isFixed ? "fixed" : "absolute"}
        isAbsolute={isAbsolute}
        onChange={opt => {
          console.log('opt', opt);
          const newValue = isMulti ? opt.map(o => o.value) : (opt ? opt.value : null);
          field.onChange(newValue);
        }}
        isClearable={isClearable}
        placeholder={placeholder}
        error={error}
        disabled={disabled}
        styleOptions={{
          control: (base) => ({
            ...base,
            minHeight: '31px',
            height: '31px',
            fontSize: '14px',
            borderRadius: '4px',
            borderColor: '#aaa'
          }),
          valueContainer: (base) => ({
            ...base,
            padding: '2px 8px',
            height: '31px'
          }),
          input: (base) => ({
            ...base,
            margin: 0,
            padding: 0
          }),
          indicatorsContainer: (base) => ({
            ...base,
            height: '31px'
          })
        }}
        //
        // ASYNC stuff
        // async={async}
        // defaultOptions={defaultOptions}
        // loadOptions={loadOptions}
        //
        // additional props
        // filterOption={filterOption}
      />
    </div>
  );
});

export default Select;
